import { Grid, useMediaQuery } from "@mui/material";
import { DateField, Labeled, TextField, useRecordContext } from "react-admin";

import { settings } from "app";
import { SectionTitle } from "features/SectionTitle";

const BipSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record?.userInfo?.isBip) return null;

  return (
    <>
      <SectionTitle
        paddingY={2}
        title="BIP"
        textAlign="center"
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="BIP име">
            <TextField
              source="userInfo.bipName"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="BIP номер">
            <TextField
              source="userInfo.bipNumber"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="BIP начална дата">
            <DateField
              locales="bg-BG"
              source="userInfo.bipStartDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="BIP крайна дата">
            <DateField
              locales="bg-BG"
              source="userInfo.bipEndDate"
              emptyText="-"
            />
          </Labeled>
        </Grid>
      </Grid>
    </>
  );
};

export default BipSection;
